import React from 'react';
import styled from 'styled-components';
import * as dayjs from 'dayjs';
import { Link, useHistory } from 'react-router-dom';
import { Delete } from 'styled-icons/material';
import { Play } from 'styled-icons/boxicons-regular';
import { Pause } from 'styled-icons/foundation';
import { Eye } from 'styled-icons/heroicons-solid';
import { EditAlt, Share, ShareAlt } from 'styled-icons/boxicons-solid';
import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import PropTypes from 'prop-types';
import { palette } from '../../../system/styles/styles';

const Container = styled.a`
  background: ${(props) =>
    props.closed ? 'repeating-linear-gradient(45deg, #EEE, #EEE 5px, #FFF 5px, #FFF 10px)' : palette.white};
  width: 100%;
  height: 85px;
  margin: auto;
  display: grid;
  grid-template-columns: 2% 29% 7% 24% 32%;
  grid-column-gap: 1rem;
  cursor: pointer;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  margin-bottom: 15px;
  transition: 0.3s;
  transform: scale(0.99);
  @media screen and (min-width: 1900px) {
    grid-template-columns: 2% 30% 9% 34% 20%;
  }

  &:hover {
    transition: 0.2s;
    transform: scale(1);
  }

  .status {
    margin: auto;
  }

  .status_color {
    transform: translateY(4px);
    width: 8px;
    height: 8px;
    border-radius: 4px;
  }

  .title {
    margin: auto 0px;

    a {
      font-size: 1.1rem;
      color: ${palette.black} !important;
      margin: 0px;
      font-weight: 500;
      text-decoration: none;
    }

    p {
      font-size: 0.9rem;
    }
  }

  .fecha {
    margin: auto;

    h1 {
      font-size: 0.9rem;
      color: #aeaec1 !important;
      margin: 0px;
    }
  }

  .location {
    margin: auto;

    h1 {
      font-size: 0.8rem;
      color: #aeaec1 !important;
      margin: 0px;
      text-align: center;
    }
  }

  .options {
    margin: auto;
    align-items: center;
    display: flex;

    button {
      border-radius: 3px;
      margin-right: 5px;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 65px;
      padding: 0px;
      background-color: transparent;
      transition: 0.2s;
      display: flex;
      flex-direction: column;
    }

    button:focus {
      outline: none;
    }

    button:active {
      outline: none;
    }

    button:hover {
      outline: none;

      .links_share {
        visibility: visible;
        opacity: 1;
        width: auto;
        font-size: 0.7rem;
        transition: 0.5s;
        background-color: ${palette.white};
        border: ${palette.black} solid 1px;
        justify-content: center;
        display: flex;
        margin-top: 2%;
        position: absolute;
        z-index: 10000;
        padding: 2%;

        img {
          margin: 4%;
          height: 20px;
          width: 20px;
        }
      }
    }
  }

  .links_share {
    background-color: transparent;
    color: ${palette.blue} !important;
    text-align: center !important;
    padding: 0px;
    transition: 0.3s;
    opacity: 0;
    display: none;
    width: 100%;
    font-size: 0rem;
    border-radius: 6px;
    margin: 0px;
  }
  button {
    box-shadow: none;
    cursor: pointer;
    border: none;
  }
`;

const VacanteCard = (props) => {
  const {
    jobID,
    // onRemovePermanent,
    onPlay,
    mode,
    Status,
    edit,
    jobTitle,
    createdAt,
    locationName,
    isConfidential,
    claims,
    companyIsBB,
    companyName,
    closed,
    onPause,
  } = props;
  const { t } = useTranslation(['jobs']);

  // const handleRemovePermanent = () => {
  //   onRemovePermanent({ id: jobID });
  // };

  const handlePlay = () => {
    onPlay({ id: jobID });
  };

  const goToView = () => {
    if (mode === 'draft') {
      window.alert('Vacante en borrador.');
    } else if (Status === false) {
      window.alert('Vacante eliminada, primero reactivela.');
    } else if (Status === 'Paused') {
      window.alert('Vacante pausada, primero reactivela.');
    } else {
      // document.location.reload()
      window.open(`${document.location.ancestorOrigins[0]}/vacantes/${jobID}`);
    }
  };

  const goToEdit = () => {
    edit(jobID);
  };

  const getbackground = () => {
    if (closed) {
      return 'transparent';
    }
    if (Status === true) {
      return 'green';
    }
    if (!Status) {
      return 'red';
    }
    return 'yellow';
  };
  const handleRemove = () => {
    onPause(jobID);
  };
  const getbutton = () => {
    if (claims.typeuser !== 'usuario') {
      if ((Status === false || Status === 'Paused') && !closed) {
        return (
          <button type="button" onClick={handlePlay}>
            <Tooltip title={t('tooltipActivate')} placement="top-start" arrow>
              <Play size={20} color="#AEAEC1" />
            </Tooltip>
          </button>
        );
      }
      if (!closed) {
        return (
          <button type="button" onClick={handleRemove}>
            <Tooltip title={t('tooltipPause')} placement="top-start" arrow>
              <Pause size={20} color="#AEAEC1" />
            </Tooltip>
          </button>
        );
      }
    }
    return null;
  };

  return (
    <Container key={jobID} to="javascript.void(0)">
      <div className="status">
        <div
          className="status_color"
          style={{
            backgroundColor: getbackground(),
          }}
        />
      </div>
      <div className="title">
        <Link to={`/applicant-tracking/${jobID}`}>{jobTitle}</Link>
        {/* <p>{props.flag ? 'Click Jobs' : Object.values(props.defaultUniversidades || []).length > 0 ? `lapieza y ${Object.values(props.defaultUniversidades || []).length} plataformas más` : 'Solo lapieza'}</p> */}
        <p>{isConfidential ? t('Confidential') : ''}</p>
        <p>{companyIsBB ? companyName : ''}</p>
      </div>
      <div className="fecha">
        <h1>{createdAt ? dayjs(createdAt).format('DD-MM-YYYY') : 'N/A'}</h1>
      </div>
      <div className="location">
        <h1>{locationName === 'Remoto' ? t('Remote') : locationName}</h1>
      </div>
      <div className="options">
        {Status === true ? (
          <button type="button" onClick={goToView}>
            <Tooltip title={t('tooltipSee')} placement="top-start" arrow>
              <Eye size={20} color="#AEAEC1" />
            </Tooltip>
          </button>
        ) : null}

        <button
          type="button"
          id="url_vacante"
          onClick={() => {
            const url = `${document.location.ancestorOrigins[0]}/vacantes/${jobID}`;
            const textField = document.createElement('textarea');
            textField.innerText = url;
            const parentElement = document.getElementById('url_vacante');
            parentElement.appendChild(textField);
            textField.select();
            document.execCommand('copy');
            parentElement.removeChild(textField);
            NotificationManager.success(t('UrlCopied'), '', 3000);
          }}>
          <Tooltip title={t('tooltipShare')} placement="top-start" arrow>
            <ShareAlt size={20} color="#AEAEC1" />
          </Tooltip>
        </button>
        {claims?.typeuser !== 'usuario' ? (
          <button type="button" onClick={goToEdit}>
            <Tooltip title={t('tooltipEdit')} placement="top-start" arrow>
              <EditAlt size={20} color="#AEAEC1" />
            </Tooltip>
          </button>
        ) : null}
        {getbutton()}
      </div>
    </Container>
  );
};

VacanteCard.propTypes = {
  mode: PropTypes.string,
  Status: PropTypes.bool,
  jobTitle: PropTypes.string,
  closed: PropTypes.string,
  jobID: PropTypes.string,
  createdAt: PropTypes.number,
  locationName: PropTypes.string,
  companyName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  claims: PropTypes.object,
  edit: PropTypes.func,
  onPlay: PropTypes.func,
  companyIsBB: PropTypes.bool,
  isConfidential: PropTypes.bool,
  onPause: PropTypes.func,
  onRemovePermanent: PropTypes.func,
};

VacanteCard.defaultProps = {
  mode: '',
  companyName: '',
  Status: false,
  isConfidential: false,
  companyIsBB: false,
  jobTitle: '',
  closed: '',
  createdAt: 0,
  locationName: '',
  jobID: '',
  claims: {},
  edit: () => {},
  onPlay: () => {},
  onPause: () => {},
  onRemovePermanent: () => {},
};

export default VacanteCard;
